module.exports = __webpack_public_path__ + "static/media/ring.40669d7d.svg";